module.exports = __webpack_public_path__ + "img/inferCNV.5cd2476a.jpg";